import type {en} from './en'

export const ja: Record<keyof typeof en, string> = {
  appTitle: 'Hmlet マーケティング',
  signIn: 'ログイン',
  signOut: 'ログアウト',
  username: 'ユーザー名',
  password: 'パスワード',
  loginFailed: 'ユーザー名またはパスワードが違います',
  panelPipedrive: 'Pipedrive',
  panelGa4: 'GA4',
  panelAds: '広告媒体',
  panelOccupancy: '稼働率',
  period: '期間',
  compare: '比較',
  mtd: '当月累計',
  last_7: '直近7日',
  yesterday: '昨日',
  last_30: '直近30日',
  last_90: '直近90日',
  ytd: '年初から今日まで',
  applyRange: '適用',
  last_month: '先月',
  custom: '期間指定',
  cmpNone: 'なし',
  cmpPrev: '前期間',
  cmpWow: '前週比',
  cmpYoy: '昨対比',
  from: '開始',
  to: '終了',
  pickRange: '期間を選択',
  dataThrough: 'データ反映日',
  stale: 'データが古い可能性があります',
  noComparison: '比較期間のデータがありません',
  historyShort: '履歴なし',
  historyStarts: '比較データは{{date}}から利用できます。それ以前の日付はダッシュボードにありません。',
  goalsMtdCaption: '昨日までの当月累計を月間目標と比較しています。上で別の期間を選ぶと、目標もその期間に連動します。',
  goalsPeriodCaption: '目標は上の期間に連動します。月末の着地見込は、その期間の1日あたりのペースから算出し、月間目標全体と比べます。',
  secGoalsPeriod: '選択期間と目標の比較',
  goalPeriodVsTarget: '月間目標に対する当月累計',
  goalPeriodBasis: '直近{{days}}日間のペースに基づく',
  secPeriod: '選択期間',
  secGoalsMtd: '当月累計と目標の比較',
  tileOccupancy: '稼働率',
  occupancyAt: '{{month}}末',
  secCategories: 'カテゴリー別リード',
  catA: 'A 予約',
  catB: 'B 問い合わせ',
  catLine: 'LINE',
  catWeb: 'Web（A・B未分類）',
  catWebsite: 'ウェブサイト（hmlet.com）',
  catOtherChannels: 'その他のマーケティングチャネル',
  catOther: 'その他（LINE・未分類）',
  sectionGaLeads: 'チャネル別リード数（Google アナリティクス）',
  gaLeadsMonthlyNote: '2026年2月〜5月はマーケティングのシートの月次の数値です（当ダッシュボードの計測は5月19日開始）。月全体が期間に含まれる場合は合計とチャネル別の表に含まれますが、日別の数値がないため、日別グラフは2026年6月から始まります。',
  gaLeadsNote: 'カテゴリA・Bの完了ページで GA4 が数えたリード数を、訪問者を最初に連れてきたチャネル別に表示します（マーケティングのシートと同じ）。GA4 のイベント数のため、合計は Pipedrive のリード数と一致しません。サイト全体の数値で、地域では分けません。',
  tileGaLeads: 'リード数（GA4）',
  tileGaLeadsA: 'カテゴリA（GA4）',
  tileGaLeadsB: 'カテゴリB（GA4）',
  chartGaLeadsDaily: '日別のGA4リード数',
  tableGaLeads: 'チャネル別リード数（GA4）',
  colShare: '構成比',
  sectionPages: 'ページ別の訪問者数（UU）',
  pagesNote: 'マーケティングが追跡しているウェブサイトのページの、1日あたりのユニーク利用者数です。ページのデータはサイト全体のため、地域の切り替えでは変わりません。',
  tilePageTop: 'トップページUU',
  tilePageSearch: '物件検索ページUU',
  tilePageRoom: '部屋詳細ページUU',
  chartPageTop: '日別のトップページUU',
  chartPageSearch: '日別の物件検索ページUU（都市別）',
  chartPageRoom: '日別の部屋詳細ページUU',
  tablePageProperties: '物件別の部屋詳細ページUU',
  colUsers: 'ユーザー数',
  colPropertyId: '物件ID',
  cityTokyo: '東京',
  cityOsaka: '大阪',
  citySingapore: 'シンガポール',
  cityHongKong: '香港',
  chartCohortBars: '月別のリード数と成約数（リード作成月ごと）',
  cohortBarsNote: '各月に作成されたリード数と、そのリードのうち現時点までに成約した数を表示します（成約は翌月以降でもかまいません）。月の下にCVRを表示します。当月はまだ積み上がり中です。無効リードは除きます。',
  cohortCvrShort: 'CVR',
  chartCohort: 'リードコホート別CVRの推移',
  cohortNote: '各月に発生したリードのうち契約に至った割合を、リード発生月からの経過月数別に{{date}}時点まで表示します。当月は今後も増えます。無効リードは除外しています。リード作成前に契約された{{skipped}}件は対象外です。',
  cohortMaturing: '集計中',
  cohortOffset: 'リード発生月の{{n}}か月後',
  cohortAt0: '同月',
  cohortAt1: '+1か月',
  cohortAt2: '+2か月',
  cohortToDate: '現在まで',
  colTotal: '合計',
  chartMoveInActual: '実際の入居月（成約）',
  moveInDesiredNote: '期間内に発生したリードの入居希望月です。',
  moveInActualNote: '期間内に契約した案件の入居月です。',
  moveInMissingNote: '期間内に契約した案件の入居月です。入居日がない{{n}}件は表示していません。',
  chartDailyLeadsByCategory: '日別リード数（カテゴリー別）',
  hintContractRate: '成約率 {{pct}}',
  tileCrTotal: 'リードあたり成約（期間）',
  periodRatioHint: '期間内に契約した件数を、期間内に発生したリード数で割った値です。コホート別の成約率ではありません。',
  tileAdLeadsA: '広告リード A（予約）',
  tileAdLeadsB: '広告リード B（問い合わせ）',
  hintContractsOf: '成約{{n}}件、リード{{of}}件',
  tileContractRateA: '成約率 A（期間）',
  tileContractRateB: '成約率 B（期間）',
  periodShortened: '確定データがある日までに期間を短縮しました',
  searchThrough: 'Search Consoleのデータ反映日',
  tileCost: '広告費',
  tileImpressions: '表示回数',
  tileClicks: 'クリック数',
  tileLeadsA: 'リードA（予約完了）',
  tileLeadsB: 'リードB（お問い合わせ）',
  tileCpl: 'リード単価（CPL）',
  tileSessions: 'セッション数',
  tileEngaged: 'エンゲージメントセッション',
  tileEngagement: 'エンゲージメント率',
  tileSearchClicks: '検索クリック数',
  tileSearchImpr: '検索表示回数',
  tileSearchPos: '平均検索順位',
  vsPrevious: '比較期間との差',
  chartDailySpend: '日別広告費',
  chartDailyLeads: '日別リード数（A＋B）',
  chartDailySessions: '日別セッション数',
  chartChannelGroups: 'チャネルグループ別セッション数',
  tableCampaigns: 'キャンペーン別',
  tableSources: '参照元別',
  viewChart: 'グラフ',
  viewTable: '表',
  colDate: '日付',
  colCampaign: 'キャンペーン',
  colType: '種別',
  colCost: '費用',
  colImpr: '表示回数',
  colClicks: 'クリック',
  colLeadsA: 'リードA',
  colLeadsB: 'リードB',
  colLeads: 'リード',
  colOther: 'その他',
  colCpl: 'CPL',
  colSource: '参照元 / メディア',
  colChannel: 'チャネルグループ',
  colSessions: 'セッション',
  colEngRate: 'エンゲージメント率',
  colKeyEvents: 'キーイベント',
  seriesCurrent: '今期間',
  seriesPrevious: '比較期間',
  notConnected: '未連携',
  needsPipedrive:
    'UTM別のリード数・契約数、CPL、CPA、着地見込みはPipedriveから取得します。読み取り専用APIトークンとフィールド定義を待っています。',
  needsOccupancy:
    '月末稼働率（国内物件）は、営業チームのシートの共有と計算式の確定後に連携します。',
  leadsNote:
    'リード数は広告媒体が報告する数値（予約完了・お問い合わせ完了）です。Pipedriveで確認済みの数値に置き換えます。',
  forecastTitle: '月末着地見込み',
  forecastNote: '概算です。当月累計を経過日数で割り、月の日数まで延ばした単純な見込みです。',
  forecastNow: '現在',
  forecastEnd: '着地見込み',
  goalTitle: '広告リード数の目標対比',
  noTarget: '今月の目標が未設定です。管理画面（Targets、metric: ad_leads）で追加してください。',
  goalTarget: '目標',
  goalProgress: '達成',
  goalPace: 'ペース',
  goalForecast: '着地見込み対目標',
  days: '日',
  dataSources: 'データソース',
  neverRun: '未実行',
  loading: '読み込み中',
  error: 'エラーが発生しました',
  retry: '再試行',
  pageNotFound: 'ページが見つかりません',
  navOverview: '概要',
  navGroupSources: 'データソース',
  navGroupExplore: '分析',
  navGroupSystem: 'システム',
  navGoogleAds: 'Google広告',
  navSearch: 'Search Console',
  navMeta: 'Meta広告',
  navReddit: 'Reddit広告',
  navGoals: '目標',
  navFunnel: 'ファネル',
  navChannels: 'チャネル',
  navCreatives: 'クリエイティブ',
  navHealth: 'データの状態',
  navGlossary: '用語集',
  panelGlossary: '用語集',
  qGlossary: '各数値は何を意味し、どう計算されているか',
  glossaryWhat: '何の数字か',
  glossaryFormula: '計算方法',
  glossarySource: 'データの出どころ',
  glossaryCaution: '注意点',
  glossaryMore: '全ての用語を見る',
  glossaryAria: '{{name}}とは？',
  glossarySearch: '用語を検索',
  glossaryNone: '該当する用語がありません。',
  glossaryExport: 'CSVをダウンロード',
  qOverview: '今月は目標に対して順調か、費用はいくらか、リードはどこから来ているか、数字は信頼できるか。',
  qAds: '有料広告は効率的か。キャンペーン別の費用、リード、リード単価。',
  qGa4: 'サイトへの流入はどのくらいで、どう動いているか。',
  qSearch: 'ウェブサイトが自然検索でどのように表示されているか。',
  qPipedrive: '確定したリードと成約は何件で、どこから来ているか。',
  qOccupancy: '物件の稼働状況はどうか。',
  qGoals: '月次目標に対して順調か、どのくらいの差か。',
  qFunnel: '訪問、リード、成約の各段階で、どこで離脱しているか。',
  qChannels: 'どのチャネルが費用に見合っているか。',
  qCreatives: 'どの広告が成果を出しているか。',
  qHealth: '表示されている数字は信頼できるか。',
  exportCsv: 'CSVをダウンロード',
  annOutage: '計測の問題',
  annMaturing: '計測途中',
  annNote: 'メモ',
  statusAhead: '先行',
  statusOnPace: '順調',
  statusBehind: '遅れ',
  statusNoTarget: '目標なし',
  statusNoData: 'データなし',
  srcName_google_ads: 'Google広告',
  srcName_ga4: 'GA4セッション',
  srcName_ga4_pages: 'GA4ページ訪問者',
  srcName_ga4_leads: 'GA4チャネル別リード',
  srcName_ga4_completions: 'GA4サンクスページ完了数（セッションのチャネル別）',
  srcName_gsc: 'Search Console',
  srcName_pipedrive: 'Pipedrive',
  srcName_meta: 'Meta（広告シート）',
  srcName_reddit: 'Reddit',
  srcName_chatgpt: 'ChatGPT広告',
  srcName_sheet: '目標・コストシート',
  srcName_occupancy: '稼働率シート',
  srcName_leads_sheet: 'チャネル別リードシート',
  runStatus_ok: '正常',
  runStatus_failed: '失敗',
  runStatus_never_run: '未接続',
  statusStale: '遅延',
  goalLeads: 'リード',
  goalAdLeads: '広告リード（媒体報告値）',
  goalContracts: '成約',
  waitingPipedrive: 'Pipedrive連携待ちです。連携後に確定したリードと成約が表示されます。',
  waitingShort: 'Pipedrive連携待ち',
  noTargetShort: '目標未設定',
  goalForecast2: '着地見込',
  needPerDay: '目標達成には1日あたり{{n}}件が必要',
  basisPlatform: '媒体報告値（広告のクリックCV）',
  basisConfirmed: '確定値（Pipedrive）',
  basisPlatformShort: '媒体報告値',
  funnelSessions: 'セッション',
  funnelKeyEvents: 'キーイベント',
  funnelLeads: 'リード',
  funnelContracts: '成約',
  funnelWeakest: '最も弱いステップ',
  funnelByChannel: 'チャネル別ファネル',
  rateSessionsToLeads: 'セッション→リード',
  rateLeadsToContracts: 'リード→成約',
  keyEventsNote: 'GA4のキーイベントが未設定のため、そのステップは非表示です。',
  colChannelName: 'チャネル',
  colLeadsPlatform: 'リード（媒体報告）',
  colContracts: '成約',
  colCpa: 'CPA',
  colSpendShare: '費用シェア',
  colContractShare: '成約シェア',
  badgeAd: '広告',
  colMonth: '月',
  colQuery: '検索クエリ',
  colPage: 'ページ',
  colPosition: '平均掲載順位',
  colSourceName: 'ソース',
  colStatus: '状態',
  colLastRun: '最終実行',
  colRows: '行数',
  colPeriod: '期間',
  colNote: 'メモ',
  tileTotalCost: '広告費合計（手数料込み）',
  tileOverallCpl: '全体CPL',
  tileAdCpl: '広告CPL（媒体報告値）',
  tileCpa: 'CPA',
  overLimit: '上限超過：',
  underLimit: '上限内：',
  tileCtr: 'CTR',
  tileKeyEvents: 'キーイベント',
  keyEventsOff: '未設定',
  tileLine: 'LINEリード',
  lineCounted: 'リードに含む',
  lineNotCounted: 'リードに含まない',
  tileInvalid: '無効リード',
  invalidNote: 'リードから除外',
  byMoveIn: '入居日基準',
  byContractDate: '契約日基準',
  tileCwRate: 'リードあたり成約（期間）',
  tileDaysToContract: '成約までの日数（中央値）',
  chartDailyClicks: '日別クリック数',
  chartDailyImpr: '日別表示回数',
  chartDailyContracts: '日別成約数',
  chartMoveIn: '入居希望月',
  chartCountries: '国別リード',
  chartOccupancy: '月末稼働率',
  chartCumulative: '月初来の累計と目標：{{metric}}',
  tableChannels: 'チャネル別',
  seeChannels: 'チャネル詳細を開く',
  tableUtm: 'UTM別のリードと成約',
  tableMonthly: '月別 {{year}}',
  shareTitle: '費用シェアと成約シェア',
  mappingTitle: 'UTMとチャネルの対応',
  mappingNote: '最初に一致したルールが適用されます。*は任意または前方一致です。',
  mappingAdmin: '管理画面（Channels, Channel rules）でルールを編集できます。',
  brandSplit: 'ブランド検索と一般検索（クリック数）',
  brandQueries: 'ブランド',
  genericQueries: '一般',
  topQueries: '上位クエリ',
  topPages: '上位ページ',
  secGoals: '目標',
  secEfficiency: '費用と効率',
  secFunnel: 'ファネル',
  changesTitle: '変化したこと',
  changesNone: 'しきい値を超える変化はありません。',
  changesPickComparison: '上で比較を選ぶと、変化したことが表示されます。',
  chgCampaignCpl_up: '{{subject}}：リード単価が{{pct}}%上昇（{{before}}から{{now}}）',
  chgCampaignCpl_down: '{{subject}}：リード単価が{{pct}}%低下（{{before}}から{{now}}）',
  chgSessions_up: '{{subject}}のセッションが{{pct}}%増加（{{before}}から{{now}}）',
  chgSessions_down: '{{subject}}のセッションが{{pct}}%減少（{{before}}から{{now}}）',
  chgPosition_better: '平均掲載順位が{{delta}}改善（{{before}}から{{now}}）',
  chgPosition_worse: '平均掲載順位が{{delta}}悪化（{{before}}から{{now}}）',
  chgClicks_up: '検索クリックが{{pct}}%増加（{{before}}から{{now}}）',
  chgClicks_down: '検索クリックが{{pct}}%減少（{{before}}から{{now}}）',
  trustTitle: 'この数字は信頼できる？',
  reconNote: '広告媒体の報告は{{platform}}件、Pipedriveで確定したのは{{confirmed}}件です（差 {{gap}}）。',
  reconNone: 'Pipedrive連携後に、媒体報告値と確定値の差を表示します。',
  occupancyChip: '{{month}}末の稼働率 {{rate}}',
  issuesCount_one: 'この期間に既知のデータ問題が{{count}}件',
  issuesCount_other: 'この期間に既知のデータ問題が{{count}}件',
  needsAdsCsv: '{{platform}}は未連携です。エクスポートを読み込むには: python manage.py ingest {{platform}} --csv file.csv',
  needsCreatives: '最初のGoogle広告の更新（python manage.py ingest google_ads）後にクリエイティブが表示されます。',
  creativesNote: '成果は媒体報告値です。成約に結びついた広告はPipedriveの広告単位の計測と連携後に表示します。',
  creativesShown: '表示中',
  sortBy: '並べ替え',
  sort_cost: '費用',
  sort_leads: 'リード',
  sort_clicks: 'クリック',
  sort_ctr: 'CTR',
  noImage: '画像なし',
  goalActual: '実績',
  goalTargetLine: '目標ペース',
  goalsPlan: '目標は{{plan}}を使用。先行は着地見込が目標の{{ahead}}以上、遅れは{{behind}}未満です。',
  planQ2: 'Q2計画',
  planBudget: '予算ブロック（KPIシート）',
  costAgency: '代理店手数料（{{rate}}%）',
  costScope: '費用は広告プラットフォームの広告費に代理店手数料を加えたものです。接続済みのプラットフォーム（現在はGoogle広告のみ）が対象で、Meta、Reddit、ChatGPTは接続後に追加されます。Instagram運用費やその他費用は含みません。',
  monthlyNote: '接続済みのデータソースより前の実績は、マーケティングチームの月次ワークブックの値です。',
  campaignDetailNote: '選択期間の日別費用、リード、リード単価。',
  occLatest: '稼働率',
  occPrevious: '前月',
  occNote: '月末稼働率（国内物件、営業チームのシート）。',
  wsTitle: 'プロジェクトの状況',
  wsIntro: 'ダッシュボードの現在の状況：利用できる機能、対応中の項目、確認中の事項、今後の予定を一覧にしています。',
  ws_done: '完了',
  ws_partial: '対応中',
  ws_waiting: '確認中',
  ws_todo: '予定',
  wsItem: '項目',
  wsUnlocks: '詳細',
  wsNext: '詳細',
  wsNeeds: '詳細',
  wsGroup_feature: '現在利用できる機能',
  wsGroup_access: 'アクセス',
  wsGroup_stakeholder: '確認中の事項',
  wsGroup_engineering: '予定している作業',
  wsGroup_later: '今後の予定',
  wsFeatureNote: '「完了」は実データで動作していること、「対応中」は既知の制約があることを示します。',
  wsAccessNote: 'ダッシュボードが利用しているログイン・共有・キー。',
  wsAnswerNote: '次の変更を決める定義や判断。',
  wsOursNote: '予定している開発作業。',
  wsLaterNote: '基本機能の後に予定しているアイデア。',
  healthSources: 'データソース',
  healthIssues: '既知のデータ問題',
  healthCosts: 'ダッシュボードの広告費とマーケティングチームのWEB広告費',
  healthRuns: '最近の更新履歴',
  issuesAdmin: '管理画面（Annotations）で追加・編集できます。',
  costNone: '比較できる月がまだありません。',
  costOurs: 'ダッシュボード',
  costReported: 'マーケティングチーム報告',
  costGap: '差',
  costGapNote: '2026年5月以降、マーケティングチームのWEB広告費は媒体の消化額を上回っています。内訳（他媒体、代理店手数料、マージンなど）は未確認です。',
  plan_budget: '予算',
  plan_q2: 'Q2',
  targetPlanLine: '使用中の目標：{{plan}}計画。',
  unattributed: '不明',
  toggleTheme: 'テーマを切り替え',
  searchScopeNote: 'Search Consoleはhmlet.comドメイン全体（全ての国）のデータで、日本のみではありません。ページはホスト名付きで表示します。',
  tileLeadsWeb: 'Webリード（A・B未分類）',
  tileLeadsWebsite: 'ウェブサイトのリード',
  tileLeadsOther: 'その他チャネルのリード',
  tileWebAdLeads: 'Web広告リード',
  insTitle: 'AIインサイト',
  insLoading: 'インサイトを読み込み中',
  insNotConfigured: 'このサーバーではAIインサイトがまだ設定されていません。',
  insNone: 'この地域のインサイトはまだありません。1日1回自動で作成されます。「再生成」でも作成できます。',
  insImpact_high: '影響大',
  insImpact_medium: '影響中',
  insImpact_low: '影響小',
  insWhy: '重要な理由:',
  insAction: '次の一手:',
  insRisks: 'リスク',
  insCaveats: 'データ上の注意',
  insRegenerate: '再生成',
  insGenerating: '生成中（約1分）',
  insCooldown: 'あと{{n}}分で再実行できます',
  insGenerated: '{{time}}（日本時間）に{{model}}で生成',
  insUsage: '本日: {{n}}/{{limit}}回、{{tokens}}トークン',
  region: '地域',
  regionAll: '全地域',
  regionJp: '日本',
  regionSg: 'シンガポール',
  regionHk: '香港',
  regionShowJapan: '日本を表示',
  regionUnsupportedTitle: '{{region}}は未対応です',
  regionUnsupportedJapanOnly: 'このページは日本のみ対象です。広告アカウント、目標、費用、稼働率は日本分のみで、地域別にはまだ分けられません。',
  regionUnsupportedGeneric: 'このデータは地域別にまだ分けられません。',
  regionUnsupportedSearch: 'Search Consoleはhmlet.comドメイン全体を対象としており、シンガポールと香港にはまだ分けられません。日本と全地域で表示します。',
  regionOverviewJapanOnly: '目標、広告費、広告リード、リード単価、成約単価は日本のみで、この地域ではまだ表示できません。下のリード、成約、セッション、ファネルは選択した地域で表示します。',
  regionLeadNote: 'シンガポールと香港のリードには日本のA・Bルールを使いません。ウェブサイトのリードは、リードソースがWeb経由のもの、または予約ページのメディアを持つRespond.ioです。その他のチャネルは、Platform、Agents、Unbounce、その他のRespond.ioです。それ以外のリードソースは集計しません。リードはディールとPipedriveのリード受信箱から取得し、契約は署名日が入力された時点で集計します。',
  costJapanOnlyNote: 'チャネル別のリード単価・成約単価は日本のみで、この地域ではまだ表示できません。',
  ga4RegionNote: 'セッションはサイト別に分けています。singapore.hmlet.comはシンガポール、hongkong.hmlet.comは香港、それ以外（hmlet.com、japan.hmlet.com）は日本です。hmlet.com内のシンガポール・香港向けページへの訪問も日本に含まれます。',

  cmtTitle: '今週のポイント',
  cmtPeriod: '{{from}}〜{{to}}（比較: {{pfrom}}〜{{pto}}）',
  cmtBasis: 'このページの数値からルールで自動生成しています。変化と既知のデータ問題のみを記載し、原因は推測しません。',
  cmtNone: '今週はコメントすべき変化はありません。',
  cmtLeads_up: 'リードは{{pct}}%増加（{{before}}件から{{now}}件）。',
  cmtLeads_down: 'リードは{{pct}}%減少（{{before}}件から{{now}}件）。',
  cmtAdLeads_up: '広告リード（媒体報告値）は{{pct}}%増加（{{before}}件から{{now}}件）。',
  cmtAdLeads_down: '広告リード（媒体報告値）は{{pct}}%減少（{{before}}件から{{now}}件）。',
  cmtContracts_up: '成約は{{pct}}%増加（{{before}}件から{{now}}件）。',
  cmtContracts_down: '成約は{{pct}}%減少（{{before}}件から{{now}}件）。',
  cmtWeakest: 'ファネルで最も弱いステップ: 「{{step}}」への移行率が{{pct}}%低下（{{before}}から{{now}}）。',
  cmtGoal_behind: '{{metric}}は遅れています。月末の着地見込は目標の{{pct}}%で、1日あたり{{need}}件が必要です。',
  cmtGoal_ahead: '{{metric}}は順調です。月末の着地見込は目標の{{pct}}%です。',
  cmtIssue: 'データ上の問題 {{from}}〜{{to}}: {{text}}',
  cmtUtmLow: 'UTMがあるのはリードの{{pct}}のみのため、チャネル別の結果は実際より少なく表示されます。',
  platformGoogle: 'Google広告',
  platformMeta: 'Meta広告',
  platformReddit: 'Reddit広告',
  chartDailyAdLeads: '日別広告リード数（クリックCV）',
  adLeadsLagNote: '媒体報告値（クリックコンバージョンのみ）。直近の数日はコンバージョンの反映が遅れるため、今後増える可能性があります。',
  chartDailySpendByPlatform: '日別広告費（媒体別）',
  costHiddenNote: 'チャネル別のリード単価・成約単価は、UTM計測が整い次第表示されます。',
  metaMissingHint: 'Google広告費と代理店手数料のみ。MetaとRedditの広告費はまだ取り込んでいません。',
  definitionsTitle: 'リード数の定義',
  definitionsNote: 'リード: Pipedriveの有効リード（A + B + LINE、無効リードは除外）。広告リード（媒体報告値）: 広告媒体が報告するクリックコンバージョン。Web広告リード: UTMが広告チャネルに該当するPipedriveリード（UTMがPipedriveに入るまでは実際より少なく表示）。リードあたり成約（期間）: 期間内の契約数を期間内のリード数で割った値。リードコホート別CVR: ある月のリードのうち、後に契約に至った割合。',
  webAdLeadsHint: 'UTMが広告チャネルに該当するリード。UTMがあるのはリードの{{pct}}です。',
  webAdLeadsUnderstated: 'UTMがPipedriveに入るまでは実際より少なく表示されます。',
  webNotSplit: 'PipedriveではAとBを区別できていません',
  chartDailyLeadsAll: '日別リード数',
  utmCoverageNote: 'PipedriveのリードにUTMソースが入っていないものが大半のため、不明として表示されます。フォームからPipedriveへの連携でUTMを渡せるようにすると、チャネル別の結果が正確になります。',
  reconLowUtm: 'PipedriveのリードでUTMがあるのは{{pct}}のみのため、チャネル別のリード数は過小になります。チャネル別のリード単価は媒体報告値で計算し、チャネル別CPAはUTM計測が改善されるまで非表示です。',
  funnelKept: 'が次へ進んだ割合',
  funnelLost: 'が離脱',
  funnelScaleNote: 'すべてのステップが見えるように、バーの幅は対数目盛りです。バーの長さではなく、割合を比べてください。',
  pointsShort: 'pt',
  occupancyMonths: '月別の稼働率',
  chartSpendLeads: 'キャンペーン別の広告費とリード',
  chartSpendLeadsAria: '広告費と媒体報告のリードの散布図（キャンペーンごとに1点）',
  spendLabel: '広告費',
  leadsLabel: 'リード',
  cplShort: 'リード単価',
  limitShort: '上限',
  chartCplTrend: 'リード単価（直近7日間の推移）',
  chartCplTrendAria: '直近7日間のリード単価と上限の折れ線グラフ',
  cplTrendNote: '広告費合計を、直近7日間の Pipedrive リード数（AとB）で割った値です。色付きの範囲は上限以内です。',
  spendLeadsNote: '点線はリード単価の上限です。点線より上の点は、リード単価が上限より低いキャンペーンです。リード数は広告媒体の報告値です。広告費には代理店手数料を含みます。横軸上のキャンペーンは、リードが 0 件のまま費用が発生しています。',
  colPlatform: '媒体',
  colSpend: '広告費',
  targetsSource: '目標はマーケティングチームの目標シートから毎晩読み込みます（最終読み込み：{{date}}）。目標を変更するには、シートを編集します。',
  targetsNeverRead: '目標はマーケティングチームの目標シートから毎晩読み込みます。まだ読み込まれていません。',
  targetsSheetLink: '目標シートを開く',
  targetsReadFailed: '目標シートの最後の読み込みに失敗したため、表示中の目標は最新でない可能性があります。',
  colChangeClicks: 'クリック数の増減',
  boardTitle: '検索クエリボード',
  boardNote: '注目したい検索クエリです。Search Console は日ごとに上位のクエリのみを保持するため、表示されないクエリが検索されていないとは限りません。',
  boardRising: '伸びているクエリ',
  boardFalling: '減っているクエリ',
  boardNew: '新しいクエリ',
  boardOpportunities: '順位改善の候補',
  boardRisingHint: '比較期間よりクリックが増えたクエリ',
  boardFallingHint: '比較期間よりクリックが減ったクエリ（表示されなくなったものを含む）',
  boardNewHint: '比較期間にクリックがなかったクエリ',
  boardOpportunitiesHint: 'よく表示され、順位が4〜20位で、ブランド名ではないクエリ。順位が上がればクリックが増えます',
  boardNeedsCompare: '比較を選ぶと、伸びている・減っている・新しいクエリが表示されます。',
  boardEmpty: '該当なし',
  boardPosition: '{{n}}位',
  searchNew: '新規',
  searchChangeNote: '増減は、選択期間のクリック数から比較期間のクリック数を引いた値です。新規は、比較期間にクリックがなかったものです。',
  changePassword: 'パスワードを変更',
  cpIntro: '{{n}}文字以上で入力してください。よくあるパスワードやメールアドレスは避けてください。',
  cpCurrent: '現在のパスワード',
  cpNew: '新しいパスワード',
  cpConfirm: '新しいパスワード（確認）',
  cpSave: '保存',
  cpDone: 'パスワードを変更しました。',
  cpErrWrong: '現在のパスワードが正しくありません。',
  cpErrSame: '新しいパスワードは、現在のパスワードと異なるものにしてください。',
  cpErrMismatch: '新しいパスワードが一致しません。',
  cpErrLocked: '試行回数が多すぎます。数分後にもう一度お試しください。',
  cpErrShort: '新しいパスワードは12文字以上にしてください。',
  cpErrCommon: 'このパスワードはよく使われているため使用できません。',
  cpErrNumeric: '数字だけのパスワードは使用できません。',
  cpErrSimilar: 'パスワードがメールアドレスに似ています。',
  cpErrOther: 'パスワードを変更できませんでした。もう一度お試しください。',
  navGroupDeep: '詳細分析',
  navSegments: 'セグメント',
  qSegments: 'どのようなリードが入り、そのうちどのようなリードが成約しているか。',
  segTitle_nationality: '国籍別のリードとコンバージョン',
  segTitle_purpose: '滞在目的別のリードとコンバージョン',
  segTitle_stay_length: '滞在予定期間別のリードとコンバージョン',
  segTitle_previous_stay: '初めての利用と過去利用別のリードとコンバージョン',
  segTitle_budget: '月額予算別のリードとコンバージョン',
  segTitle_language: '契約言語別のリードとコンバージョン',
  segCol_nationality: '国籍',
  segCol_purpose: '滞在目的',
  segCol_stay_length: '滞在予定期間',
  segCol_previous_stay: '利用',
  segCol_budget: '予算',
  segCol_language: '言語',
  segVal_nationality_japanese: '日本国籍',
  segVal_nationality_non_japanese: '外国籍',
  segVal_purpose_travel: '旅行',
  segVal_purpose_study: '就学',
  segVal_purpose_work: '仕事',
  segVal_purpose_other: 'その他',
  segVal_purpose_multi_location: '複数拠点生活',
  segVal_purpose_returning_home: '一時帰国・本帰国',
  segVal_stay_length_1_3: '1〜3か月',
  segVal_stay_length_3_6: '3〜6か月',
  segVal_stay_length_6_12: '6〜12か月',
  segVal_stay_length_12_plus: '12か月以上',
  segVal_previous_stay_first: '初めての利用',
  segVal_previous_stay_returning: '過去利用あり',
  segVal_language_english: '英語',
  segVal_language_japanese: '日本語',
  segRecorded: 'リードの{{pct}}で入力あり',
  segPairs: '滞在目的と国籍の組み合わせ',
  segNote: 'コンバージョン率は、これらのリードのうち{{date}}までに成約した割合です。直近のリードはまだ成約までの時間がないため、最近の期間は低く表示されます。国、職業、年齢はPipedriveに記録されていないため、セグメントはリードがフォームに入力した内容を使っており、入力されているのはリードの一部のみで、多くは商談が進むなかで入力されるため、値のあるリードは「未記録」より成約率が大きく高くなります。全体の率ではなく、同じグラフ内で比較してください。セグメント別の成約単価は、ディールにUTMが残らないため表示していません。',
  segSignedShort: '成約',
  segSigned: '成約済み',
  segRate: 'コンバージョン率',
  segTileLeads: 'この期間のリード',
  segTileSigned: 'うち成約済み',
  segTileRate: '現時点のコンバージョン率',
  segUnknown: '未記録',
  segOther: 'その他のセグメント',
  segLowTitle: 'リードが{{n}}件未満のため、率は参考程度にしてください',
  segChangeLeads: 'リード数の変化',
  segPairsNote: '多い組み合わせです。件数が少ない率は、1件の成約で大きく動きます。',
  segRegions: '地域別の比較',
  segNone: 'この期間のリードはありません。',
  navTiming: '問い合わせのタイミング',
  qTiming: '成約したお客様はいつ最初に問い合わせたか。新しいリードはいつ届くか。',
  timingContracts: '成約数',
  timingMedian: '問い合わせから成約までの日数（中央値）',
  timingWithin7: '7日以内に成約',
  timingWithin30: '30日以内に成約',
  timingDaysUnit: '{{n}}日',
  chartTimingDays: '問い合わせから成約までの日数別の成約数',
  chartTimingMonths: '問い合わせ月別の成約数',
  timingOffset0: '成約と同じ月',
  timingOffsetN: '成約の{{n}}か月前',
  timingOffset1: '成約の1か月前',
  timingOffsetEarlier: '成約の{{n}}か月以上前',
  timingBucket0: '当日',
  timingBucket1_3: '1〜3日',
  timingBucket4_7: '4〜7日',
  timingBucket8_14: '8〜14日',
  timingBucket15_30: '15〜30日',
  timingBucket31_60: '31〜60日',
  timingBucket61_90: '61〜90日',
  timingBucket91_plus: '91日以上',
  chartArrivalWeek: '到着週別のリード数',
  chartArrivalWeekday: '曜日別のリード数（1日あたり平均）',
  timingOtherChannels: 'その他のチャネル',
  timingUnjoined: 'タイミングのグラフから除外：リードの記録がない成約 {{noLead}}件、リード作成日より前の日付の成約 {{before}}件。',
  timingArrivalNote: '期間の最初と最後の週は一部の日のみの場合があります。チャネルが分かるのはUTMのあるリードだけで、残りは「不明」です（この期間のリードのUTM保有率：{{pct}}）。',
  timingMonthsNote: '月数は、問い合わせの月から成約の月までで数えています。',
  colWeekOf: '週（開始日）',
  colWeekday: '曜日',
  colAvgPerDay: '1日あたり平均',
  colRange: '日数',
  colShareOfContracts: '割合',
  timingBucketShort0: '当日',
  timingBucketShort1_3: '1-3',
  timingBucketShort4_7: '4-7',
  timingBucketShort8_14: '8-14',
  timingBucketShort15_30: '15-30',
  timingBucketShort31_60: '31-60',
  timingBucketShort61_90: '61-90',
  timingBucketShort91_plus: '91+',
  timingDaysAxis: '問い合わせから成約までの日数',
  navBehavior: 'サイト内の行動',
  qBehavior: 'サイトに来た訪問者はどのくらい関心を持って閲覧しているか。チャネルによって違いはあるか。',
  behEngagement: 'エンゲージメント率',
  behBounce: '直帰率',
  behPages: 'セッションあたりのページ数',
  behTime: '平均エンゲージメント時間',
  behSeconds: '{{s}}秒',
  behMinutes: '{{m}}分{{s}}秒',
  chartBehChannel: 'チャネルグループ別の直帰率',
  chartBehWeek: '週別のエンゲージメント率',
  behChannelNote: 'セッション全体の{{n}}未満のチャネルグループはグラフに含めていません。期間の最初と最後の週は一部の日のみの場合があります。',
  behDefinitions: '10秒以上滞在した、キーイベントが発生した、または2ページ以上閲覧したセッションをエンゲージセッションとします。直帰率は、エンゲージしなかったセッションの割合です。',
  colEngagementRate: 'エンゲージメント率',
  colBounceRate: '直帰率',
  colPagesPerSession: 'セッションあたりのページ数',
  colAvgEngaged: '平均エンゲージメント時間',
  colKeyPer100: '100セッションあたりのキーイベント数',
  tableBehChannel: 'チャネルグループ別の行動',
  ga4gDirect: 'ダイレクト',
  ga4gOrganicSearch: 'オーガニック検索',
  ga4gPaidSearch: '有料検索',
  ga4gOrganicSocial: 'オーガニックソーシャル',
  ga4gPaidSocial: '有料ソーシャル',
  ga4gReferral: '参照',
  ga4gEmail: 'メール',
  ga4gDisplay: 'ディスプレイ',
  ga4gCrossNetwork: 'クロスネットワーク',
  ga4gUnassigned: '未割り当て',
  ga4gAffiliates: 'アフィリエイト',
  ga4gAudio: 'オーディオ',
  ga4gOrganicVideo: 'オーガニック動画',
  ga4gPaidVideo: '有料動画',
  ga4gOrganicShopping: 'オーガニックショッピング',
  ga4gPaidShopping: '有料ショッピング',
  ga4gMobilePush: 'モバイルプッシュ通知',
  ga4gSms: 'SMS',
  ga4gAiAssistant: 'AIアシスタント',
  ga4gPaidOther: 'その他の有料',
  ga4gOrganicOther: 'その他のオーガニック',
  pgHome: 'ホーム',
  pgSearch: '都市別の検索ページ',
  pgRoom: 'お部屋の詳細ページ',
  pgCampaign: 'キャンペーンページ',
  pgPreview: '物件プレビューページ',
  pgAbout: '会社紹介ページ',
  pgNews: 'ニュースページ',
  pgFaq: 'よくある質問ページ',
  pgOther: 'その他のページ',
  pgEntry: '前のページなし',
  pgExternal: '外部サイト',
  tableBehLanding: 'ランディングページ（訪問の開始ページ）',
  colPageType: 'ページの種類',
  colShareSessions: 'セッションの割合',
  tableBehJourney: 'フォームまでの流れ',
  jrSessions: 'すべてのセッション',
  jrSearch: '都市別の検索ページを閲覧',
  jrRoom: 'お部屋の詳細ページを閲覧',
  jrFormClick: 'フォームへ進んだ',
  jrFormDone: 'フォームを完了（完了ページ）',
  colOfSessions: 'セッションに占める割合',
  colOfClicked: 'フォームへ進んだ人のうちの割合',
  behJourneyNote: '各ステップは、その行動を1回以上行ったセッションの数です。1つのセッションが複数のステップに含まれることがあります。すべてのステップを、全セッションに対する割合で示します。フォームのイベントは日本のみ計測しています。',
  behJourneyNone: '流れのイベントは日本のみ計測しているため、この地域に表示できるデータはありません。',
  tableBehJourneyChannel: 'チャネルグループ別の流れ',
  colViewedRoom: 'お部屋を閲覧',
  colClickedForm: 'フォームへ進んだ',
  colCompletedForm: 'フォーム完了',
  tableBehMoves: 'よくあるページ間の移動',
  chartBehMoves: 'よくあるページ間の移動',
  colFromPage: '移動元',
  colToPage: '移動先',
  colMoves: '閲覧数',
  colShareMoves: '移動に占める割合',
  behMovesNote: '各移動は1回の閲覧で、訪問者が移動する前と後のページを種類ごとにまとめています。「前のページなし」はそのページから訪問が始まったこと、「外部サイト」はhmlet.com以外から来たことを表します。',
  behFromNote: 'ランディングページ、フォームまでの流れ、ページ間の移動は{{date}}以降のデータです。',
  colStep: 'ステップ',
  navAwareness: '認知施策の効果',
  qAwareness: '認知施策の費用が多い週は、ブランド検索や成約も多いか。',
  awIntro: '認知施策の費用は、Meta、Google デマンドジェネレーション、Reddit（連携後）で、代理店手数料を含みます。このページでは、その費用と、後から現れる2つの結果との間にパターンがあるかを見ます。原因を示すものではありません。費用、検索、成約はいずれも季節やマーケティングの予定に合わせて増減するためです。',
  awWindow: '表示期間：{{from}}〜{{to}}（{{days}}日間）。認知施策の費用があり、すべてのデータがそろっている日です。',
  awNone: 'まだデータが十分ではありません。このページには、認知施策の費用、Search Console、Pipedriveのデータが少なくとも{{n}}日分必要です。',
  chartAwSpend: '週別の認知施策の費用',
  chartAwSearch: '週別の Search Console クリック数',
  chartAwContracts: '週別の成約数',
  awBrandedClicks: 'ブランド検索',
  awOtherClicks: 'その他の検索',
  platformDemandGen: 'Google デマンドジェネレーション',
  tableAwLag: '認知施策の費用と、後の結果',
  chartAwLag: 'ラグ別の相関',
  colLag: 'ラグ（日）',
  colBrandedCorr: 'ブランド検索',
  colContractsCorr: '成約',
  colDaysUsed: '使用日数',
  awStrength_none: 'はっきりした関係なし',
  awStrength_weak: '弱い',
  awStrength_moderate: '中程度',
  awStrength_strong: '強い',
  awStrength_insufficient: '日数が不足',
  awStable: '前半・後半で同じ方向',
  awUnstable: '前半と後半で方向が変わる',
  awLagNote: '各数値は、ある日の費用と、その日数後の結果との相関（−1〜1）で、曜日のパターンを除いて計算しています。参考値であり、期間の前半と後半が同じ方向を向いている場合のみ「安定」としています。',
  awLimitsTitle: 'ご注意',
  awLimit1: 'Redditはまだ連携していないため、費用に含まれていません。',
  awLimit2: 'ブランド検索は、Search Console が日ごとに保存している上位クエリから集計しています。',
  awLimit3: '使用しているのは{{n}}日分のデータのみです。原因を確かめるには、ホールドアウトテストや地域別のテストが確実です。',
  awLimit4: 'デマンドジェネレーションの費用は{{date}}から、Metaは{{meta}}からです。',
  awLimit5: '広告シートにはどのキャンペーンが認知施策かの区別がないため、Metaの費用はリード獲得のキャンペーンも含めてすべて数えています。',
  behStepNote: '一部のステップは途中の日付から計測を始めているため、それ以前の日は集計に含まれません：{{list}}。',
  awLag0: '同日',
  awLag1: '1日後',
  awDaysLater: '{{n}}日後',
  language: '言語',
  navAssistant: 'アナリストアシスタント',
  qAssistant: 'マーケティングの数値について質問すると、ダッシュボードのデータから回答します。',
  asstPlaceholder: 'リード、成約、費用、チャネル、検索、訪問者などについて質問してください',
  asstSend: '質問する',
  asstThinking: '数値を確認しています...',
  asstNew: '新しい会話',
  asstTry: '質問の例',
  asstHow: '計算の根拠',
  asstHowIntro: '数値は、次のダッシュボードの機能から取得しています（アシスタントが選んだ入力を表示）：',
  asstFailedCall: '失敗',
  asstUnverified: '回答内の次の数値は、データと照合できませんでした。利用前に確認してください：{{list}}',
  asstQuestion: '質問',
  asstAnswer: '回答',
  asstNotReady: 'このサーバーではアナリストアシスタントがまだ設定されていないため、質問に回答できません。',
  asstOff: 'このサーバーではアナリストアシスタントがオフになっています。',
  asstSuggest1: '今月これまでのリードと成約は、前の期間と比べてどうですか？',
  asstSuggest2: '直近30日で、リード単価が最も低いチャネルはどれですか？',
  asstSuggest3: '最初の問い合わせから成約まで、どのくらいかかりますか？',
  asstSuggest4: '今月、費用が最も多いGoogle広告のキャンペーンはどれですか？',
  asstSuggest5: '直近30日で、クリックが最も増えた検索クエリはどれですか？',
  asstSuggest6: '問い合わせの前に、訪問者はどこで離脱していますか？',
  asstSuggest7: '今月の稼働率はどうですか？',
  asstErr_not_configured: 'このサーバーではアナリストアシスタントがまだ設定されていません。',
  asstErr_disabled: 'このサーバーではアナリストアシスタントがオフになっています。',
  asstErr_invalid: '先に質問を入力してください。',
  asstErr_too_long: '質問または回答が長くなりすぎました。質問を絞ってください。',
  asstErr_busy: '前の質問に回答中です。',
  asstErr_rate: '1分間の質問数が多すぎます。少し待ってからもう一度お試しください。',
  asstErr_limit_user: '1日の質問数の上限に達しました。明日リセットされます。',
  asstErr_limit_day: 'アシスタントの1日の上限に達しました。明日リセットされます。',
  asstErr_provider: 'AIサービスが回答できませんでした。しばらくしてからもう一度お試しください。',
  asstErr_too_many_steps: '質問の処理に手順がかかりすぎました。一度に1つのことを質問してください。',
  asstErr_refused: 'AIサービスがこの質問への回答を見送りました。',
  asstErr_error: '問題が発生しました。もう一度お試しください。',
  tool_get_overview: '概要の数値',
  tool_get_channels: 'チャネル別の表',
  tool_get_ads: '広告キャンペーン',
  tool_get_search: 'Search Console',
  tool_get_timing: '問い合わせのタイミング',
  tool_get_behavior: 'サイト内の行動',
  tool_get_awareness: '認知施策の効果',
  tool_get_cohorts: 'リードのコホート',
  tool_get_daily_series: '日別・週別の推移',
  tool_get_data_status: 'データの状態',
  tool_calculate: '計算',
  kpiTitle: '目標に対する月初来の実績',
  kpiCaption: 'リードと成約は、マーケティングチームが使うPipedriveビューと同じ条件で集計しています。広告リードと広告費は代理店シート（GoogleとMeta、1時間ごとに更新、広告費は代理店手数料込み）の数値です。予測は月初来のペースを月末まで延ばした値です。',
  kpiSheetRead: '代理店シートの最終読み込み：{{time}}（1時間ごと）。',
  kpiThrough: '{{date}} 23:59（JST）までのデータ（{{total}}日中{{elapsed}}日経過）',
  kpiColKpi: '項目',
  kpiColTarget: '目標',
  kpiColActual: '実績',
  kpiColVsTarget: '目標比',
  kpiColForecast: '月末予測',
  kpiColForecastVsTarget: '予測の目標比',
  kpiLeads: 'リード（Pipedrive、AとB）',
  kpiAdLeads: '広告リード（代理店シート）',
  kpiContracts: '成約（Pipedrive、CW）',
  kpiSpend: '広告費合計（代理店シート）',
  kpiCpl: 'CPL',
  kpiAdCpl: '広告CPL',
  kpiCpa: 'CPA',
  kpiWithin: '目標内',
  kpiOver: '目標超過',
  kpiNoData: 'GA4のサンクスページデータはまだありません。',
  chartKpiDailyAdLeads: '日別 広告リード',
  chartKpiDailyAdCpl: '日別 広告CPL',
  chartKpiDailySpend: '日別 広告費',
  adGroupGoogleSearch: 'Google検索',
  adGroupDemandGen: 'デマンドジェネレーション',
  adGroupMeta: 'Meta',
  adGroupChatgpt: 'ChatGPT',
  adGroupReddit: 'Reddit',
  chartKpiAdCplByGroup: 'チャネル別 広告CPL',
  chartKpiAdCplByGroupNote: '広告費を広告リードで割った値を、チャネルごとに表示します。広告リードのない日はCPLがないため、線から除いています。',
  moveInTitle: '入居希望月',
  moveInNote: '選択した期間のリード（上の表と同じリード）を、希望された入居月ごとに集計しています。',
  moveInMonth: '入居希望月',
  moveInShare: '割合',
  moveInTotal: '合計',
  moveInNotEntered: '未入力',
  tableCostChannels: 'チャネル別 費用とリードあたり費用',
  tableCostChannelsNote: '費用は代理店シートの値（媒体費と代理店手数料の合計）です。リードあたり費用は、その費用を同じチャネルのGA4サンクスページ完了数で割った値です。「-」は完了数がないことを示します。Redditはシートが週次更新のため、データのある最終日までの値です。',
  colCostJpy: '費用',
  colCompletionsShort: '完了数',
  colCplCompletions: 'CPL',
  colDataThrough: 'データ反映日',
  tableTargets: 'リードと成約の目標達成状況',
  colTargetRow: '区分',
  colLeadsTarget: 'リード目標',
  colLeadsActual: 'リード',
  colLeadsVs: 'リード目標比',
  colCwTarget: 'CW目標',
  colCwActual: 'CW（成約）',
  colCwVs: 'CW目標比',
  rowTotal: '合計',
  tableTargetsNote: '目標は「Marketing targets」シートの月次目標を期間の日数で按分した値です。AとB別の目標はまだシートにないため、該当行は目標なしで表示します。',
  tableGaSessions: 'チャネル別 GA4セッションとサンクスページ完了数',
  colCompletions: 'サンクスページ完了数',
  colCompletionsA: '完了数 A',
  colCompletionsB: '完了数 B',
  kpiThroughPeriod: '{{from}} から {{to}}。目標は月間目標を日数で按分した値で、この期間には月末予測はありません。{{date}} 23:59（JST）までのデータ。',
  colCvr: 'CVR',
  colCvrTip: 'サンクスページ完了数を同じチャネルのセッション数で割った値',
  navCompetitors: '競合分析',
  panelCompetitors: '競合分析',
  qCompetitors: 'この地域の競合は誰で、いくらで、何をしているか。',
  compIndexTitle: '市場に対する価格',
  compHmlet: 'Hmletの代表的な「から」価格',
  compMarket: '市場の中央値（競合{{n}}社）',
  compVsMarket: 'Hmletと市場の差',
  compNoHmlet: 'この地域のHmlet価格はまだありません。競合レジストリのmanual_pricesに追加してください。',
  compPickRegion: '価格指数は地域を1つ選ぶと表示されます。通貨が異なるためです。',
  compPricesTitle: '広告されている月額価格',
  compPricesNote: '各社の公開ページに載っている月額の「から」賃料。最終的な支払額ではありません。自社の価格は参考値です。',
  compSiteTitle: 'サイトとSEO',
  compSiteNote: 'サイトマップとトップ・都市ページから。速度はGoogle PageSpeed（モバイル）で、Google APIキー設定後に表示されます。',
  compStackTitle: 'ページ内のマーケティングツール',
  compStackNote: 'ページに直接書かれたツール。タグマネージャーで後から読み込まれるものは見えないため、無いことの証明にはなりません。',
  compMarketTitle: '評判と検索',
  compMarketNote: 'Googleマップの評価と、対象キーワードでのGoogle検索順位。週次で更新。',
  compFeedTitle: '最近の変化',
  compFeedEmpty: 'まだ変化はありません。2回目の日次実行から表示されます。',
  compBlockedTitle: '自動で取得していないサイト',
  compColCompetitor: '競合',
  compColSegment: '区分',
  compColTypical: '代表価格',
  compColRange: '幅',
  compColOffers: '取得数',
  compColAsOf: '取得日',
  compColPages: 'ページ数',
  compColFresh: '90日以内の更新',
  compColLangs: '言語',
  compColSchema: '構造化データ',
  compColH1: 'H1',
  compColAlt: 'alt無し画像',
  compColHtml: 'HTML容量',
  compColSpeed: '速度スコア',
  compColAds: '広告ツール',
  compColOther: 'その他ツール',
  compColRating: 'Google評価',
  compColTop10: '上位10位のキーワード',
  compColBest: '最高順位',
  compColWhen: '日付',
  compColKind: '種別',
  compColWhat: '内容',
  compSegment_furnished_monthly: '家具付き月額',
  compSegment_share_house: 'シェアハウス',
  compSegment_coliving: 'コリビング',
  compSegment_serviced: 'サービスアパート',
  compAccess_robots: 'robots.txtで禁止',
  compAccess_challenge: 'ボット対策あり',
  compAccess_pending: 'サイト未確認',
  compNone: 'なし',
  compKind_price: '価格',
  compKind_pages: 'ページ',
  compKind_tech: 'ツール',
  compKind_news: 'ニュース',
  compKind_access: 'アクセス',
  compLastRun: '最終実行: {{runs}}',
  compMarketKind: '市場の中央値（{{kind}}の競合{{n}}社）',
  compMarketEmpty: '評価・検索データはまだありません。週次ジョブで入ります（評価は追加設定不要、検索順位はSerpApiキーが必要）。',
  compColYoutube: 'YouTube登録者数',
  compSummaryTitle: '現在の立ち位置',
  compCoverage: 'データ取得状況（{{total}}社中）：価格{{prices}}、速度{{speed}}、評価{{ratings}}、YouTube{{youtube}}、検索{{search}}、規模{{scale}}。',
  compLegend: '緑は良好、黄は要注意、赤は要対応。色はあえて薄くしています。',
  vPriceAbove: '当社の代表価格は、比較可能な競合{{n}}社の中央値より{{pct}}%高い。',
  vPriceBelow: '当社の代表価格は、比較可能な競合{{n}}社の中央値より{{pct}}%安い。',
  vSearch: '{{keywords}}キーワード中、上位10位に入るのは{{top10}}件。最多の競合は{{rival}}（{{rival_top10}}件）。',
  vSpeed: '当社のページ速度スコアは{{score}}。競合の中央値は{{median}}。',
  vAlt: '当社の画像の{{pct}}%にalt属性がありません。',
  vSchemaNone: '当社ページには構造化データがありません。',
  vSchemaYes: '当社ページには構造化データがあります（{{types}}）。',
  vRating: '当社のGoogle評価は{{rating}}。最高の競合は{{rival}}（{{rival_rating}}）。',
  compColUnits: '規模',
  compColByKind: '部屋タイプ別',
  compKind_shared: 'シェア',
  compKind_private: '個室',
  compKind_studio: 'スタジオ',
  compKind_1br: '1BR',
  'compKind_2br+': '2BR+',
  compNoPrice: '価格データなし：{{names}}。',
  compHistoryTitle: '代表価格の推移',
  compHistoryNote: '月次。本日より前はInternet Archiveに保存された各社ページから取得しており、欠けがある場合があります。',
  compSearchTitle: '検索：キーワード別の順位',
  compSearchNote: 'Googleでの順位（各社の最上位ページ、10位以内のみ）。「当社」はキーワードを含む検索の過去90日のSearch Consoleの実績。',
  compColKeyword: 'キーワード',
  compColRanks: '上位の事業者',
  compColUs: '当社（Search Console）',
  compColReach: 'サイト人気順位',
  compColWeight: 'ページ容量',
  compColField: '実ユーザー',
  compThemesTitle: '入居者の声',
  compThemesNote: '最近の公開Googleレビューの傾向をAIで要約したもの。サンプルは少数のため参考値です。',
  compColPraise: '好評',
  compColComplaints: '不満',
  compNoSearch: '検索データは週次実行で入ります。',
  compPlus: '{{n}}件のレビュー',
  navDeployments: 'デプロイ',
  qDeployments: 'どのバージョンが公開中か、デプロイは実行中か、何が変わったか。',
  depLiveNow: '現在公開中',
  depVersion: 'バージョン {{version}}',
  depLiveSince: '{{when}} から公開中（実行者: {{who}}）',
  depUpToDate: '最新の状態です',
  depDeployingNow: 'バージョン {{version}} をデプロイ中です（{{minutes}} 分前に開始）',
  depLastFailed: '直近のデプロイは失敗しました。ダッシュボードは以前のバージョンのまま動作しています。',
  depRolledBackNote: '直近の試行より古いバージョンで動作しています（ロールバック済み）。',
  depRestarting: 'デプロイを完了するためダッシュボードを再起動しています。このページは自動で再接続します。',
  depRunLink: 'デプロイの実行状況を見る',
  depHistory: 'デプロイ履歴',
  depColVersion: 'バージョン',
  depColBy: '実行者',
  depColDuration: '所要時間',
  depColChanged: '変更内容',
  depMinutes: '{{n}} 分',
  depShow: '表示',
  depHide: '閉じる',
  depDetails: '技術的な詳細（コミットメッセージ）',
  depRunning: 'デプロイ中',
  depSucceeded: '公開中',
  depFailed: '失敗',
  depRolledBack: 'ロールバック',
  depWrittenAuto: 'コードの変更から自動で作成しています。',
  depFromCommits: '開発者のコミットメッセージです。',
  depNoSummary: '説明はありません。',
  depDirty: '未保存の変更を含む作業コピーからデプロイしたため、説明はありません。',
  depEmpty: 'まだデプロイの記録がありません。履歴は次のデプロイから始まります。稼働中のバージョン: {{version}}。',
  depBackups: 'バックアップ',
  depBackupOk: '最近のバックアップがあります。',
  depBackupStale: '最新のバックアップが1日以上前です。バックアップのジョブを確認してください。',
  depBackupNewest: '最新: {{when}}、{{kb}} KB。',
  depBackupCount: 'デプロイ前のダンプをサーバーに {{n}} 件保持しています。',
  depDrillOk: '直近の復元テストは成功しました（{{when}}）。',
  depDrillBad: '直近の復元テストに失敗しました（{{when}}）。',
  depDrillNone: '復元テストはまだありません。',
  depBackupUnknown: 'バックアップの状況はまだ取得できません。',
  depRollbackTitle: 'ロールバック',
  depRollbackNote: 'コードを以前のバージョンに戻します。データベースはそのままです。先にバックアップを取ります。',
  depNoTargets: '戻せる以前のバージョンがありません。',
  depSafe: '安全: そのバージョン以降のデータベース変更なし',
  depReview: '要確認: そのバージョン以降にデータ移行あり',
  depUnsafe: 'ブロック: そのバージョン以降のデータベース変更により動かなくなります',
  depImagePruned: 'イメージ削除済み',
  depBlocked: 'ブロック',
  depRollBack: 'ロールバック',
  depCancel: 'キャンセル',
  depConfirmTitle: 'バージョン {{version}}（{{sha}}）にロールバックしますか。',
  depConfirmBackup: '先にデータベースのバックアップを取ります。ダッシュボードは約15秒間使えなくなります。',
  depMigrations: 'そのバージョン以降のデータベース変更:',
  depReviewed: 'この移行内容を確認したうえでロールバックします。',
  depReason: 'ロールバックの理由（必須）',
  depRequests: '最近のロールバック依頼',
}
